import type { ISingleLineForm } from './types';
import { CompanyWebsiteForm } from './companyWebsite';
import { EmailForm } from './email';


export const SingleLineForm = ({
  variant = 'email',
  ...props
}: ISingleLineForm) => {
    switch (variant) {
      case 'email':
        return <EmailForm {...props} />;
      case 'companyWebsite':
        return <CompanyWebsiteForm {...props} />;
      default:
        return <EmailForm {...props} />;
    }
  };
